import { ReactElement } from 'react';
import { UIText } from '@/ui';
import styles from './task-data-section-header.module.scss';

type TaskDataSectionHeaderProps = { title: string; rightText?: string };

export function TaskDataSectionHeader(
    props: TaskDataSectionHeaderProps
): ReactElement {
    const { title, rightText } = props;
    return (
        <div className={styles.container}>
            <UIText>{title}</UIText>
            {rightText && (
                <UIText variant="small" type="default2">
                    {rightText}
                </UIText>
            )}
        </div>
    );
}
